import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Category from "@/model/Category";
import Paging, {PagingQueryForm} from "biz-ts/src/api/Paging";

@Singleton
export default abstract class CategoryApi {
    abstract list(): Promise<Array<Category>>

    abstract paging(form: PagingQueryForm): Promise<Paging<Category>>
}

class CategoryApiImpl extends BaseApi implements CategoryApi {

    protected urlPrefix = 'category'

    list(): Promise<Array<Category>> {
        return this.axios.post('list')
    }

    paging(form: PagingQueryForm): Promise<Paging<Category>> {
        return this.axios.post('paging', form)
    }
}

Container.bind(CategoryApi).to(CategoryApiImpl)
